import useModal from '@/hooks/use-modal/index'
import { useTranslation } from 'react-i18next'
import PackageOwnerModal from './package-owner-modal.jsx'

export default function PackageOwnerSwitch({ sendOwner, receiveOwner, type, title, submit, isRemoved, isDeclined, isCopy }) {

	const { t } = useTranslation()

	const { visible: isPackageOwnerModalVisible, hide: hidePackageOwnerModal, show: showPackageOwnerModal } = useModal()

	return (
		<div className="eclip-package-owner">
			<PackageOwnerModal visible={isPackageOwnerModalVisible} currentOwner={type === 'SEND' ? sendOwner : receiveOwner}
				close={hidePackageOwnerModal} submit={submit}
			/>
			<div className="eclip-package-owner__title">{title}</div>
			<div className="eclip-package-owner__selected">
				<div className='eclip-package-owner__label'>Sender</div>
				<div className={`eclip-package-owner__input ${((type !== 'SEND' || isRemoved || isDeclined) || isCopy) && 'disabled'}`}>
					<div className="eclip-package-owner__name">{sendOwner || "-"}</div>
					{type === 'SEND' && !isRemoved && !isDeclined && (
						<div className="eclip-package-owner__change" onClick={showPackageOwnerModal}>
						{t('Change')}
						</div>
					)}
				</div>
			</div>
			<div className="eclip-package-owner__selected">
				<div className='eclip-package-owner__label'>Receiver</div>
				<div className={`eclip-package-owner__input ${((type === 'SEND' || isRemoved || isDeclined) || isCopy) && 'disabled'}`}>
					<div className="eclip-package-owner__name">{receiveOwner || "To be filled by receiver"}</div>
					{type !== 'SEND' && !isDeclined && (
						<div className={`eclip-package-owner__change ${isCopy && 'disabled'}`} onClick={isCopy? null: showPackageOwnerModal}>
						{t('Change')}
						</div>
					)}
				</div>
			</div>
		</div>
	)
}
